import React from "react"
import { Button, Grid, Typography } from "@material-ui/core"

import HardCoded from "@/services/HardCoded"

const UninassauFeatures: React.FC = () => {
	const canViewUninassauFeaturePage = HardCoded.checkFeatureFlag("canViewUninassauFeaturePage")
	if (!canViewUninassauFeaturePage) {
		window.location.replace("/admin")
	}

	return (
		<Grid container>

			<Grid
				item
			>
				<Typography
					variant="h3"
				>
					Relatórios
				</Typography>
				<Button
					variant="contained"
					color="primary"
					target="_blank"
					href="https://grafana-customers.appdot.letalk.com.br"
				>
					Abrir relatórios no Grafana
				</Button>
			</Grid>

		</Grid>
	)
}

export default UninassauFeatures
